import { Component, OnInit, Input } from '@angular/core';
import { ActionService } from 'src/app/services/action.service';
import { IAction, IActionSubtype } from '../../../model/action.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable, Subject, tap } from 'rxjs';

@Component({
    selector: 'app-account-query-action-form',
    templateUrl: './account-query-action-form.component.html',
    styleUrls: ['./account-query-action-form.component.scss'],
})
export class AccountQueryActionFormComponent implements OnInit {
    @Input() subFormIsLoading$: Subject<boolean>;
    @Input() form: FormGroup;
    @Input() action: IAction;

    subtypes: IActionSubtype[];

    constructor(private actionService: ActionService) {}

    ngOnInit(): void {
        this.loadFormData().subscribe(() => {
            this.extendFormControls();
            this.subFormIsLoading$.next(false);
        });
    }

    fieldIsValid(filedName: string): boolean {
        return this.form.get(filedName).invalid && (this.form.get(filedName).dirty || this.form.get(filedName).touched);
    }

    private loadFormData(): Observable<any> {
        const actionId = this.form.get('actionType').value;
        return this.actionService.getSubtypes(actionId).pipe(
            tap((subtypes) => {
                this.subtypes = subtypes;
            })
        );
    }

    private extendFormControls() {
        this.form.addControl('subtypeId', new FormControl(this.action.subtypeId, [Validators.required]));
        this.form.addControl('subject', new FormControl(this.action.subject, [Validators.required]));
        this.form.addControl('customerId', new FormControl(this.action.customer?.id));
        this.form.addControl('sendNotificationToCustomer', new FormControl(false));
    }
}
